import React from 'react';
import { Container, Row, Col, Card } from 'reactstrap';
import { useAuth } from "../../store/auth";
import { contactData, mapLocation } from '../../data';
import { contactDataArabic } from '../../data/indexArabic';

export default function ContactSection() {
  const { isArabic } = useAuth();
  const data = isArabic ? contactData : contactDataArabic;

  const getLinkHref = (item) => {
    switch (item.title.toLowerCase()) {
      case 'phone':
      case 'الهاتف':
        return `tel:${item.data}`;
      case 'email':
      case 'البريد الإلكتروني':
        return `mailto:${item.data}`;
      case 'location':
      case 'الموقع':
        return mapLocation;
      default:
        return '#';
    }
  };

  return (
    <React.Fragment>
      {data && (
        <Container>
          <Row>
            {data.map((item, key) => (
              <Col md={4} key={key}>
                <Card className="border-0 text-center features feature-primary feature-clean rounded-3 shadow-sm p-4 contact-card">
                  <div className="icons text-center mx-auto">
                    <i className={`uil ${item.icon} d-block rounded h3 mb-0 text-primary`}></i>
                  </div>
                  <div className="content mt-4">
                    <h5 className="fw-bold">{item.title}</h5>
                    <p className="text-muted">{item.discription}</p>
                    <a
                      href={getLinkHref(item)}
                      target={item.title.toLowerCase() === 'location' || item.title === 'الموقع' ? '_blank' : '_self'}
                      rel="noopener noreferrer"
                      className="text-primary"
                      style={{ direction: 'ltr', unicodeBidi: 'embed' }}
                    >
                      {item.data}
                    </a>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      )}
    </React.Fragment>
  );
}